import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Button, Container, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, FormControlLabel, Link, Alert, TextField, Box, InputAdornment } from '@mui/material';
import './KontorAl.css';
import KullanimKosullari from './KullanimKosullari';
import GizlilikPolitikasi from './GizlilikPolitikasi';
import MesafeliSatisSozlesmesi from './MesafeliSatisSozlesmesi';
import TeslimatIade from './TeslimatIade';
import { styled, keyframes } from '@mui/material/styles';
import { doc, updateDoc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { database } from './firebaseConfig';
import { auth } from './firebaseConfig';
import { CheckCircle, CreditCard as CreditCardIcon } from '@mui/icons-material';
import PaymentService from './PaymentService';

const CircularCheckbox = styled(Checkbox)({
  padding: 0,
  '& .MuiSvgIcon-root': {
    borderRadius: '50%',
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiTouchRipple-root': {
    borderRadius: '50%',
  }
});

// Animasyonlar
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const checkmark = keyframes`
  0% {
    stroke-dashoffset: 100;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const KontorAl = ({ currentKontor = 0, onKontorUpdate }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [agreements, setAgreements] = useState({
    privacy: false,
    distance: false,
    delivery: false
  });
  const [modalContent, setModalContent] = useState({
    open: false,
    type: null
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [localKontor, setLocalKontor] = useState(currentKontor);
  
  // Ödeme Dialog State'leri
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [cardDetails, setCardDetails] = useState({
    cardNumber: '',
    cardName: '',
    expiryDate: '',
    cvv: ''
  });

  // Real-time kontör dinleyicisi
  useEffect(() => {
    const currentUser = auth.currentUser;
    if (!currentUser || !currentUser.email) return;
    
    const kontorDocRef = doc(database, `users/${currentUser.email}/kontor/current`);
    
    const unsubscribe = onSnapshot(kontorDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const kontorData = docSnapshot.data();
        const newAmount = kontorData.amount || 0;
        setLocalKontor(newAmount);
        console.log('KontorAl sayfasında kontör güncellendi:', newAmount);
      } else {
        setLocalKontor(0);
      }
    }, (error) => {
      console.error('KontorAl kontör dinleyici hatası:', error);
    });
    
    return () => unsubscribe();
  }, []);

  // currentKontor prop'u değiştiğinde local state'i güncelle
  useEffect(() => {
    setLocalKontor(currentKontor);
  }, [currentKontor]);

  const packages = [
    // TEST PAKETİ - Geçici olarak gizlendi
    // {
    //   amount: 1,
    //   price: 1,
    //   features: [
    //     'TEST PAKETİ',
    //     'Sadece Test Amaçlı',
    //     'Gerçek Ödeme Alınmaz'
    //   ],
    //   isTest: true,
    //   label: 'TEST'
    // },
    {
      amount: 100,
      price: 300,
      features: [
        'Anında Aktivasyon',
        'Sınırsız Süre Geçerlilik',
        '7/24 Destek'
      ]
    },
    {
      amount: 1000,
      price: 2500,
      features: [
        'Anında Aktivasyon',
        'Sınırsız Süre Geçerlilik',
        '7/24 Destek',
        'Öncelikli Destek'
      ]
    },
    {
      amount: 2000,
      price: 4000,
      features: [
        'Anında Aktivasyon',
        'Sınırsız Süre Geçerlilik',
        '7/24 Destek',
        'Öncelikli Destek',
        'VIP Hizmet'
      ]
    }
  ];

  const handlePurchase = (pkg) => {
    setSelectedPackage(pkg);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setAgreements({
      privacy: false,
      distance: false,
      delivery: false
    });
  };

  const handleConfirmPurchase = async () => {
    if (agreements.privacy && agreements.distance && agreements.delivery) {
      // Sözleşmeler onaylandı, ödeme dialog'unu aç
      handleCloseDialog();
      setOpenPaymentDialog(true);
    }
  };
  
  const handlePaymentSubmit = async () => {
    setLoading(true);
    setErrorMessage('');
    
    try {
      const currentUser = auth.currentUser;
      if (!currentUser || !currentUser.email) {
        throw new Error("Kullanıcı bilgisi alınamadı. Lütfen tekrar giriş yapın.");
      }
      
      console.log('🚀 Ödeme başlatılıyor...');
      
      // PaymentService ile ödeme başlat
      const paymentData = {
        amount: selectedPackage.price,
        packageInfo: selectedPackage,
        cardDetails: cardDetails,
        customerInfo: {
          email: currentUser.email,
          city: 'İstanbul',
          phone: '5555000000'
        }
      };
      
      console.log('📋 Ödeme verileri:', paymentData);
      
      // 3D Secure ödeme başlat
      const result = await PaymentService.initiatePayment(paymentData);
      
      console.log('✅ API yanıtı:', result);
      
      if (result.success) {
        console.log('🔒 3D Secure sayfasına yönlendiriliyor...');
        console.log('📄 HTML Form içeriği:', result.htmlForm ? 'Var' : 'Yok');
        
        if (result.htmlForm) {
          // 3D Secure HTML formunu işle
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = result.htmlForm;
          tempDiv.style.display = 'none';
          document.body.appendChild(tempDiv);
          
          // Formu bul ve submit et
          const forms = tempDiv.getElementsByTagName('form');
          if (forms && forms.length > 0) {
            const form = forms[0];
            console.log('📝 3D Secure form bulundu, submit ediliyor...');
            console.log('📍 Form action:', form.action);
            console.log('📍 Form method:', form.method);
            
            // Form'u yeni sekmede aç (test için)
            if (window.confirm('3D Secure sayfası açılacak. Devam etmek istiyor musunuz?')) {
              form.target = '_self'; // Aynı sekmede aç
              form.submit();
            }
          } else {
            // Form yoksa, hata detayı göster
            console.error('⚠️ Form bulunamadı!');
            console.log('📄 Gelen HTML:', tempDiv.innerHTML.substring(0, 500));
            alert('3D Secure formu bulunamadı. Console\'u kontrol edin.');
            window.location.href = `/payment/fail?error=no_3d_form`;
          }
        } else if (result.redirectUrl) {
          // Doğrudan yönlendirme URL'si varsa
          window.location.href = result.redirectUrl;
        } else {
          console.error('❌ 3D Secure formu alınamadı');
          console.log('📋 API Yanıtı detayı:', result);
          throw new Error('3D Secure formu alınamadı');
        }
      } else {
        throw new Error(result.message || 'Ödeme başlatılamadı');
      }
      
      handleClosePaymentDialog();
    } catch (error) {
      console.error('❌ Ödeme hatası:', error);
      setErrorMessage(`Ödeme başlatılamadı: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (name) => (event) => {
    setAgreements({ ...agreements, [name]: event.target.checked });
  };
  
  const handleClosePaymentDialog = () => {
    setOpenPaymentDialog(false);
    setCardDetails({
      cardNumber: '',
      cardName: '',
      expiryDate: '',
      cvv: ''
    });
  };
  
  const handleCardInputChange = (field) => (event) => {
    let value = event.target.value;
    
    // Kart numarası formatlaması
    if (field === 'cardNumber') {
      value = value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
      if (value.length > 19) return; // 16 digit + 3 boşluk
    }
    
    // Expiry date formatlaması
    if (field === 'expiryDate') {
      value = value.replace(/\D/g, '');
      if (value.length >= 3) {
        value = value.slice(0, 2) + '/' + value.slice(2, 4);
      }
      if (value.length > 5) return;
    }
    
    // CVV formatlaması
    if (field === 'cvv') {
      value = value.replace(/\D/g, '');
      if (value.length > 3) return;
    }
    
    setCardDetails({ ...cardDetails, [field]: value });
  };

  const allAgreed = agreements.privacy && agreements.distance && agreements.delivery;

  const handleModalOpen = (type) => {
    setModalContent({
      open: true,
      type: type
    });
  };

  const handleModalClose = () => {
    setModalContent({
      open: false,
      type: null
    });
  };

  const renderModalContent = () => {
    switch (modalContent.type) {
      case 'terms':
        return <KullanimKosullari />;
      case 'privacy':
        return <GizlilikPolitikasi />;
      case 'distance':
        return <MesafeliSatisSozlesmesi />;
      case 'delivery':
        return <TeslimatIade />;
      default:
        return null;
    }
  };

  return (
    <Container className="kontor-container">
      <Typography variant="h3" component="h1" className="kontor-title" gutterBottom>
        Kontör Paketleri
      </Typography>
      
      <Typography variant="subtitle1" className="kontor-subtitle" gutterBottom>
        Mevcut Kontör Bakiyeniz: <strong>{localKontor.toLocaleString()}</strong>
      </Typography>
      
      <Typography variant="subtitle1" className="kontor-subtitle" gutterBottom>
        İhtiyacınıza en uygun kontör paketini seçin
      </Typography>
      
      {successMessage && (
        <Alert 
          severity="success" 
          onClose={() => setSuccessMessage('')}
          style={{ marginBottom: '20px' }}
        >
          {successMessage}
        </Alert>
      )}
      
      {errorMessage && (
        <Alert 
          severity="error" 
          onClose={() => setErrorMessage('')}
          style={{ marginBottom: '20px' }}
        >
          {errorMessage}
        </Alert>
      )}
      
      <Grid container spacing={4} className="package-container">
        {packages.map((pkg, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card className={`package-card ${index === 1 ? 'popular' : ''} ${pkg.isTest ? 'test-package' : ''}`} 
                  style={pkg.isTest ? {border: '2px dashed #ff9800', backgroundColor: '#fff3e0'} : {}}>
              {index === 1 && (
                <div className="popular-badge">
                  En Popüler
                </div>
              )}
              {pkg.isTest && (
                <div className="popular-badge" style={{backgroundColor: '#ff9800'}}>
                  TEST PAKETİ
                </div>
              )}
              <CardContent>
                <Typography variant="h4" className="kontor-amount">
                  {pkg.amount}
                  <span className="kontor-text">Kontör</span>
                </Typography>
                <Typography variant="h5" className="package-price" style={pkg.isTest ? {color: '#ff9800'} : {}}>
                  {pkg.price} TL {pkg.isTest && '(TEST)'}
                </Typography>
                <ul className="feature-list">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
                <Button 
                  variant="contained" 
                  color="primary"
                  fullWidth
                  className="purchase-button"
                  onClick={() => handlePurchase(pkg)}
                  disabled={loading}
                >
                  {loading ? 'İşleniyor...' : 'Satın Al'}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <div className="footer-links">
        <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <Link 
            onClick={() => handleModalOpen('terms')} 
            style={{ textDecoration: 'none', background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer' }}
          >
            Kullanım Koşulları
          </Link>
          <span>|</span>
          <Link 
            onClick={() => handleModalOpen('privacy')} 
            style={{ textDecoration: 'none', background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer' }}
          >
            Gizlilik Politikası
          </Link>
          <span>|</span>
          <Link 
            onClick={() => handleModalOpen('distance')} 
            style={{ textDecoration: 'none', background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer' }}
          >
            Mesafeli Satış Sözleşmesi
          </Link>
          <span>|</span>
          <Link 
            onClick={() => handleModalOpen('delivery')} 
            style={{ textDecoration: 'none', background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer' }}
          >
            Teslimat ve İade
          </Link>
        </Typography>
      </div>

      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>Satın Alma Onayı</DialogTitle>
        <DialogContent>
          <div className="purchase-summary">
            <Typography variant="h6" gutterBottom>
              Seçilen Paket: {selectedPackage?.amount} Kontör
            </Typography>
            <Typography variant="h6" gutterBottom>
              Toplam Tutar: {selectedPackage?.price} TL
            </Typography>
          </div>
          
          <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px', margin: '20px 0' }}>
            <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '10px', color: '#1976d2' }}>
              📊 Kontör Nedir ve Nasıl Kullanılır?
            </Typography>
            <Typography variant="body2" style={{ lineHeight: '1.6', color: '#666' }}>
              • Kontörleriniz ile operatör çalışma saatlerini kaydedebilirsiniz<br/>
              • Makine ve operatör bazlı puantaj girişleri yapabilirsiniz<br/>
              • Her bir yeni girilen puantaj <strong>1 kontöre</strong> bedeldir<br/>
              • Mevcut kontör bakiyeniz: <strong>{localKontor.toLocaleString()}</strong>
            </Typography>
          </div>
          
          <div className="agreements" style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '20px' }}>
            <FormControlLabel
              style={{ margin: 0 }}
              control={
                <CircularCheckbox
                  checked={agreements.privacy}
                  onChange={handleCheckboxChange('privacy')}
                />
              }
              label={
                <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
                  <Link 
                    onClick={() => handleModalOpen('privacy')}
                    style={{ textDecoration: 'none', background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer', marginRight: '4px' }}
                  >
                    Gizlilik Sözleşmesi
                  </Link>
                  'ni okudum ve kabul ediyorum.
                </Typography>
              }
            />
            <FormControlLabel
              style={{ margin: 0 }}
              control={
                <CircularCheckbox
                  checked={agreements.distance}
                  onChange={handleCheckboxChange('distance')}
                />
              }
              label={
                <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
                  <Link 
                    onClick={() => handleModalOpen('distance')}
                    style={{ textDecoration: 'none', background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer', marginRight: '4px' }}
                  >
                    Mesafeli Satış Sözleşmesi
                  </Link>
                  'ni okudum ve kabul ediyorum.
                </Typography>
              }
            />
            <FormControlLabel
              style={{ margin: 0 }}
              control={
                <CircularCheckbox
                  checked={agreements.delivery}
                  onChange={handleCheckboxChange('delivery')}
                />
              }
              label={
                <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
                  <Link 
                    onClick={() => handleModalOpen('delivery')}
                    style={{ textDecoration: 'none', background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer', marginRight: '4px' }}
                  >
                    İade Sözleşmesi
                  </Link>
                  'ni okudum ve kabul ediyorum.
                </Typography>
              }
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary" disabled={loading}>
            İptal
          </Button>
          <Button 
            onClick={handleConfirmPurchase} 
            color="primary" 
            disabled={!allAgreed || loading}
            variant="contained"
          >
            {loading ? 'İşleniyor...' : 'Satın Al'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={modalContent.open} onClose={handleModalClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {modalContent.type === 'terms' && 'Kullanım Koşulları'}
          {modalContent.type === 'privacy' && 'Gizlilik Sözleşmesi'}
          {modalContent.type === 'distance' && 'Mesafeli Satış Sözleşmesi'}
          {modalContent.type === 'delivery' && 'İade Sözleşmesi'}
        </DialogTitle>
        <DialogContent>
          {renderModalContent()}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      {/* Ödeme Dialog'u */}
      <Dialog open={openPaymentDialog} onClose={handleClosePaymentDialog} maxWidth="sm" fullWidth>
        <Box sx={{ p: 3 }}>
          {/* Başarı İkonu ve Tutar */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <CheckCircle sx={{ fontSize: 60, color: '#ff9999', mb: 2 }} />
            <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#666' }}>
              {selectedPackage?.price} TL
            </Typography>
            <Button 
              variant="outlined" 
              size="small" 
              sx={{ mt: 1, color: '#ff9999', borderColor: '#ff9999' }}
            >
              Sipariş Detayları
            </Button>
          </Box>

          {/* Ödeme Yöntemi */}
          <Box>
            {/* Kredi/Banka Kartı Başlığı */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <CreditCardIcon sx={{ color: '#ff9999' }} />
              <Typography variant="h6">Kredi / Banka Kartı</Typography>
              <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
                <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" height="20" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" height="20" />
              </Box>
            </Box>
            
            {/* Kredi Kartı Form Alanları */}
            <Box sx={{ pb: 2 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Visa veya Mastercard ile güvenli ödeme yapın
              </Typography>
                
              <TextField
                fullWidth
                label="Kart Numarası"
                placeholder="XXXX XXXX XXXX XXXX"
                value={cardDetails.cardNumber}
                onChange={handleCardInputChange('cardNumber')}
                sx={{ mb: 2 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CreditCardIcon />
                    </InputAdornment>
                  )
                }}
              />
              
              <TextField
                fullWidth
                label="Kart Üzerindeki İsim"
                placeholder="Kart Üzerindeki İsim"
                value={cardDetails.cardName}
                onChange={handleCardInputChange('cardName')}
                sx={{ mb: 2 }}
              />
              
              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <TextField
                  label="Son Kullanma Tarihi"
                  placeholder="AA/YY"
                  value={cardDetails.expiryDate}
                  onChange={handleCardInputChange('expiryDate')}
                  sx={{ flex: 1 }}
                />
                <TextField
                  label="CVV Kodu"
                  placeholder="XXX"
                  value={cardDetails.cvv}
                  onChange={handleCardInputChange('cvv')}
                  sx={{ flex: 1 }}
                />
              </Box>
            </Box>
          </Box>
          
          {/* Ödeme Yap Butonu */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handlePaymentSubmit}
            disabled={loading || !cardDetails.cardNumber || !cardDetails.cardName || !cardDetails.expiryDate || !cardDetails.cvv}
            sx={{
              mt: 3,
              py: 1.5,
              backgroundColor: '#ff9999',
              '&:hover': {
                backgroundColor: '#ff7777'
              },
              borderRadius: 3,
              textTransform: 'none',
              fontSize: '1.1rem'
            }}
          >
            {loading ? 'İşleniyor...' : 'Ödemeyi Tamamla'}
          </Button>
        </Box>
      </Dialog>

      {/* Başarı Dialog'u */}
      <Dialog 
        open={openSuccessDialog} 
        onClose={() => setOpenSuccessDialog(false)}
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden'
          }
        }}
      >
        <Box sx={{ 
          p: 4, 
          textAlign: 'center',
          background: 'white'
        }}>
          {/* Yeşil Check İkonu */}
          <Box sx={{ 
            width: 100, 
            height: 100, 
            borderRadius: '50%', 
            backgroundColor: '#4CAF50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            animation: `${pulse} 2s ease-in-out infinite`
          }}>
            <CheckCircle 
              sx={{ 
                fontSize: 60, 
                color: 'white',
                animation: `${checkmark} 0.6s ease-in-out`
              }} 
            />
          </Box>

          {/* Başlık */}
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 'bold', 
              color: '#333',
              mb: 2
            }}
          >
            Başarılı!
          </Typography>

          {/* Mesaj */}
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#666',
              mb: 3,
              fontSize: '1.1rem',
              lineHeight: 1.6
            }}
          >
            {selectedPackage?.amount} kontör hesabınıza tanımlanmıştır.
            <br />
            Kullanmaya hemen başlayabilirsiniz!
          </Typography>

          {/* OK Butonu */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              setOpenSuccessDialog(false);
              setSuccessMessage(`${selectedPackage?.amount} kontör başarıyla satın alındı!`);
            }}
            sx={{
              py: 1.5,
              backgroundColor: '#4CAF50',
              '&:hover': {
                backgroundColor: '#45a049'
              },
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem',
              fontWeight: 'bold'
            }}
          >
            TAMAM
          </Button>
        </Box>
      </Dialog>
    </Container>
  );
};

export default KontorAl; 